import React, { Component, Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import { renderForm } from "../../../actions/reportActions";
import Spinner from "../../common/Spinner";
import queryString from "query-string";
import TextFieldGroup from "../../common/TextFieldGroup";
import TextAreaFieldGroup from "../../common/TextAreaFieldGroup";
import RadioGroup from "../../common/RadioGroup";
import SelectListGroup from "../../common/SelectListGroup";
import FileGroup from "../../common/FileGroup";
import { createWebReport } from "../../../actions/reportActions";
import isEmpty from "../../../validation/is-empty";
import FaqPanel from "../faq/FaqPanel";
import MobileInputGroup from "../../common/MobileInputGroup";

import ReCAPTCHA from "react-google-recaptcha-enterprise";
ReactModal.setAppElement("#root");

class ReportQuestion extends Component {
  constructor(props) {
    //console.log("ReportQuestion", props);
    super(props);
    this.state = {
      server_id: "",
      got_char: "yes",
      character_name: "",
      email: "",
      phone: "",
      partner_uid: "",
      question_type: "",
      content: "",
      errors: "",
      file01: "",
      file02: "",
      file03: "",
      mobile_locale: "886",
      captcha_token: "",

      attachments01: [],
      attachments02: [],
      attachments03: [],
      loading: false,
      showModal: false,
      token: "",
      useRecaptcha: true,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    // this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });

    this.props.history.push(
      `/service/${this.props.match.params.game_id}/view/${
        this.props.report.create_result.question_id
      }?token=${
        isEmpty(this.props.report.settings.user)
          ? this.props.report.create_result.token
          : this.state.token
      }`
    );
  }

  onSubmit(e) {
    e.preventDefault();
    const { user, game } = this.props.report.settings;
    let formData = new FormData();
    if (this.state.question_type === "f" || this.state.question_type === "g") {
      let fileArray = this.state.attachments02;
      for (let index = 1; index <= fileArray.length; index++) {
        formData.append(`attachment_id${index}`, fileArray[index - 1]);
      }
      fileArray = this.state.attachments03;
      for (let index = 1; index <= fileArray.length; index++) {
        formData.append(`attachment_pay${index}`, fileArray[index - 1]);
      }
    } else {
      let fileArray = this.state.attachments01;
      for (let index = 1; index <= fileArray.length; index++) {
        formData.append(`attachment${index}`, fileArray[index - 1]);
      }
    }

    formData.append("email", this.state.email);
    formData.append("got_char", this.state.got_char);
    if (user) {
      formData.append("partner_uid", user.partner_uid);
      formData.append("server_id", user.server_info.server_id);
      formData.append("in_game_id", user.in_game_id);
      formData.append("character_name", user.character_name);
      formData.append("role_id", user.role_id);
      formData.append("note", user.q_note);
    } else {
      let phone =
        this.state.mobile_locale === "886"
          ? this.state.phone
          : `${this.state.mobile_locale}${this.state.phone}`;
      formData.append("phone", phone);

      formData.append(
        "server_id",
        game.servers.length === 1
          ? game.servers[0].server_id
          : this.state.server_id
      );

      formData.append(
        "character_name",
        this.state.got_char === "no" ? "" : this.state.character_name
      );
    }
    formData.append("game_id", game.game_id);
    formData.append("game_name", game.game_name);
    formData.append("question_type", this.state.question_type);
    formData.append("content", this.state.content);
    formData.append("captcha_token", this.state.captcha_token);
    formData.append("useRecaptcha", this.state.useRecaptcha);

    //console.log("formData", formData);
    
    this.props.createWebReport(formData, this.props.history);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
    //console.log(e.target.name, e.target.value);
    //console.log(e.target.files);

    if (
      e.target.name === "question_type" &&
      e.target.value.indexOf("event_") > -1
    ) {
      const event_id = e.target.value.replace("event_", "");

      this.props.history.push(
        `/events/event_serial?event_id=${event_id}&token=${this.state.token}`
      );
    }

    if (e.target.name === "question_type") {
      if (e.target.value === "f") {
        this.setState({ 
          content: "1.角色等級：\n2.角色暱稱：\n3.角色ID(個人檔案內的數字)：\n4.角色最後登入裝置型號：\n5.角色最後登入時間：\n\n※未滿十六歲需額外提供法定代理人有效證件。",
          file01: "",
          attachments01: [],
        });
      } else if (e.target.value === "g") {
        this.setState({ 
          content: "1.角色等級：\n2.角色暱稱：\n3.角色ID(個人檔案內的數字)：\n4.最後遊玩的日期與時間：\n5.遭盜用的日期與時間：\n6.是否有帳號共用：\n7.最後使用的綁定平台：\n8.創建帳號時的手機型號：\n9.最常遊玩位置的IP：\n\n※未滿十六歲需額外提供法定代理人有效證件。",
          file01: "",
          attachments01: [],
        });
      } else {
        this.setState({ 
          content: "",
          file02: "",
          attachments02: [],
          file03: "",
          attachments03: [],
        });
      }
    }

    if (e.target.name === "file01" && !isEmpty(e.target.files)) {
      if (Object.keys(e.target.files).length > 6) {
        this.setState({
          file01: "",
          errors: { file01: "請勿選取超過6個檔案" },
          attachments01: [],
        });
      } else {
        this.setState({ errors: {}, attachments01: e.target.files });
      }
    }

    if (e.target.name === "file02" && !isEmpty(e.target.files)) {
      if (Object.keys(e.target.files).length > 4) {
        this.setState({
          file02: "",
          errors: { file02: "請勿選取超過4個檔案" },
          attachments02: [],
        });
      } else {
        this.setState({ errors: {}, attachments02: e.target.files });
      }
    }

    if (e.target.name === "file03" && !isEmpty(e.target.files)) {
      if (Object.keys(e.target.files).length > 3) {
        this.setState({
          file03: "",
          errors: { file03: "請勿選取超過3個檔案" },
          attachments03: [],
        });
      } else {
        this.setState({ errors: {}, attachments03: e.target.files });
      }
    }
  }

  verifyCallback(recaptchaToken) {
    this.setState({ captcha_token: recaptchaToken });
  }

  componentDidMount() {
    const search_values = queryString.parse(this.props.location.search);

    this.setState({ token: search_values.token });
    document.title = "龍邑遊戲|客服回報單";

    this.props.renderForm(this.props.match.params.game_id, search_values.token);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.report) {
      //const { user } = nextProps.report.settings;
      //console.log("user", user);
      // if (
      //   user &&
      //   user.vendor_game_id === "h38na" &&
      //   user.q_note.indexOf("windows") > -1
      // ) {
      //   this.setState({ useRecaptcha: false });
      // }

      if (nextProps.report.create_result.question_id) {
        this.handleOpenModal();
      } else {
        this.setState({ showModal: false });
      }

      //this.setState({ question: nextProps.service.question });
    }
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  render() {
    const {
      game,
      question_types,
      user,
      faq,
      events,
    } = this.props.report.settings;
    
    const { loading } = this.props.report;
    const { question_id, check_id } = this.props.report.create_result;

    const {
      errors,
      attachments01,
      attachments02,
      attachments03,
      question_type,
      mobile_locale,
      token,
      useRecaptcha,
    } = this.state;

    if (errors.msg) {
      this.props.history.push("/support");
    }

    const localeOptions = [
      { label: "台灣 (+886)", value: "886", placeholder: "0912 345 678" },
      { label: "香港 (+852)", value: "852", placeholder: "5123 4567" },
      { label: "澳門 (+853)", value: "853", placeholder: "6612 3456" },
      { label: "新加坡 (+65)", value: "65", placeholder: "8123 4567" },
      { label: "馬來西亞 (+60)", value: "60", placeholder: "12 345 6789" },
      { label: "中國 (+86)", value: "0086", placeholder: "131 2345 6789" },
    ];

    const phone_placeholder = localeOptions.filter(
      (local) => local.value === mobile_locale
    )[0].placeholder;

    const fileInfo01 = Object.keys(attachments01).map(
      (attach) => attachments01[attach].name
    );
    const fileInfo02 = Object.keys(attachments02).map(
      (attach) => attachments02[attach].name
    );
    const fileInfo03 = Object.keys(attachments03).map(
      (attach) => attachments03[attach].name
    );

    const home_link = !isEmpty(user)
      ? `/service_quick?token=${token}`
      : `/service_quick?param_game_id=${this.props.match.params.game_id}`;

    let formContent;
    let typesOption = [
      {label: '帳號遺失', value: 'f'}, 
      {label: '帳號盜用', value: 'g'}
    ];
    let game_title;
    if (game && question_types) {
      // <? foreach($events as $e_row):?>
      // <?if ($partner_uid &&( ($e_row->status==1 && now() > $e_row->begin_time && now() < $e_row->end_time ) || IN_OFFICE)): ?>
      // <div class="form-check-inline">
      //   <input type="radio" class="form_radio" name="question_type" value="event_<?=$e_row->id?>" > <?=$e_row->event_name?> <br>
      // </div>
      // <? endif;?>
      // <? endforeach;?>

      typesOption = [
        ...typesOption,
        ...Object.getOwnPropertyNames(question_types)
        .filter((type) => type!=="f" && type!=="g")
        .map((type) => ({
        label: question_types[type],
        value: type,
      }))];
      
      let serversOption = [];

      if (game.servers) {
        serversOption = game.servers
          .filter((server) => server.server_status === "public")
          .map((server) => ({
            label: server.server_name,
            value: server.server_id,
          }));
        //console.log("serversOption", serversOption);
        if (game.servers.length > 1) {
          serversOption = [...serversOption, { label: "請選擇", value: "" }];
        }
      }

      if (game.game_name) {
        game_title = game.game_name;
      }
      if (user) {
        typesOption = [
          ...typesOption,
          ...events.map((event) => ({
            label: event.event_name,
            value: `event_${event.id}`,
          })),
        ];
        formContent = (
          <div>
            <div className="form-group">
              <label className="text-primary">
                <strong>伺服器：{user.server_info.server_name}</strong>
              </label>
              <input
                type="hidden"
                name="partner_uid"
                id="partner_uid"
                value={user.partner_uid}
              />
              <input
                type="hidden"
                name="server_id"
                id="server_id"
                value={user.server_info.server_id}
              />
            </div>

            <div className="form-group">
              <label className="text-primary">
                <strong>角色名稱：{user.character_name}</strong>
              </label>

              <input
                type="hidden"
                name="character_name"
                id="character_name"
                value={user.character_name}
              />
            </div>

            <TextFieldGroup
              placeholder="* Email"
              name="email"
              type="email"
              value={this.state.email}
              onChange={this.onChange}
              error={errors.email}
              info="我們將會使用email通知回報後續處理結果, 請務必正確填寫"
            />
          </div>
        );
      } else {
        formContent = (
          <div>
            <TextFieldGroup
              placeholder="* Email"
              name="email"
              type="email"
              value={this.state.email}
              onChange={this.onChange}
              error={errors.email}
              info="我們將會使用email通知回報後續處理結果, 請務必正確填寫"
            />
            <MobileInputGroup
              placeholder={phone_placeholder}
              name="phone"
              type="tel"
              locale_value={this.state.mobile_locale}
              localeOptions={localeOptions}
              value={this.state.phone}
              onChange={this.onChange}
              error={errors.phone}
              info="格式為純數字, 不需任何符號"
            />
            <SelectListGroup
              placeholder="伺服器"
              name="server_id"
              value={this.state.server_id}
              onChange={this.onChange}
              error={errors.server_id}
              options={serversOption}
              info="伺服器"
            />

            <div className="custom-control custom-radio">
              <input
                className="custom-control-input"
                type="radio"
                name="got_char"
                id="got_char_yes"
                value="yes"
                onChange={this.onChange}
                checked={this.state.got_char === "yes" ? true : false}
              />
              <label className="custom-control-label" htmlFor="got_char_yes">
                我有角色
              </label>
              {this.state.got_char === "yes" && (
                <TextFieldGroup
                  placeholder="* 角色名稱"
                  name="character_name"
                  type="text"
                  value={this.state.character_name}
                  onChange={this.onChange}
                  error={errors.character_name}
                  info="請填寫角色名稱"
                />
              )}
            </div>
            <div className="custom-control custom-radio mb-3">
              <input
                className="custom-control-input"
                type="radio"
                name="got_char"
                id="got_char_no"
                value="no"
                onChange={this.onChange}
                checked={this.state.got_char === "no" ? true : false}
              />{" "}
              <label className="custom-control-label" htmlFor="got_char_no">
                我沒有角色(或是我忘了角色名稱)
              </label>
            </div>
          </div>
        );
      }
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-9 col-lg-6 m-auto">
            <h4 className="text-center mt-5">{game_title} 線上回報</h4>
            <small className="d-block mb-3 text-center">請填寫以下資訊</small>

            {loading ? (
              <Spinner />
            ) : (
              <div>
                <form onSubmit={this.onSubmit}>
                  {formContent}
                  <RadioGroup
                    name="question_type"
                    value={question_type}
                    onChange={this.onChange}
                    error={errors.question_type}
                    options={typesOption}
                    info="問題類型"
                  />
                  <FaqPanel faq={faq} question_type={question_type} />
                  <TextAreaFieldGroup
                    placeholder="* 問題描述"
                    name="content"
                    value={this.state.content}
                    onChange={this.onChange}
                    error={errors.content}
                    info="請詳細描述您所遇到的遊戲問題"
                  />

                  {(question_type !== "f" && question_type !== "g") && (
                  <FileGroup
                    name="file01"
                    filename={
                      !isEmpty(fileInfo01)
                        ? `已選取${Object.keys(attachments01).length}個`
                        : "附件(最多6個)"
                    }
                    onChange={this.onChange}
                    error={errors.file01}
                    limit={6}
                    info={!isEmpty(fileInfo01) ? fileInfo01 : []}
                  />
                  )}

                  {(question_type === "f" || question_type === "g") && (
                  <Fragment><br />身分證正反面圖檔或健保卡正面圖檔
                  <FileGroup
                    name="file02"
                    filename={
                      !isEmpty(fileInfo02)
                        ? `已選取${Object.keys(attachments02).length}個`
                        : "附件(最多4個)"
                    }
                    onChange={this.onChange}
                    error={errors.file02}
                    limit={4}
                    info={!isEmpty(fileInfo02) ? fileInfo02 : []}
                  />
                  </Fragment>
                  )}

                  {(question_type === "f" || question_type === "g") && (
                  <Fragment>近期三筆儲值訂單
                  <FileGroup
                    name="file03"
                    filename={
                      !isEmpty(fileInfo03)
                        ? `已選取${Object.keys(attachments03).length}個`
                        : "附件(最多3個)"
                    }
                    onChange={this.onChange}
                    error={errors.file03}
                    limit={3}
                    info={!isEmpty(fileInfo03) ? fileInfo03 : []}
                  />
                  </Fragment>
                  )}

                  {useRecaptcha && (
                    <ReCAPTCHA
                      sitekey="6Lcyc_UbAAAAACraqz0XIzXBepnOgtAvRgPsLVuD"
                      onChange={this.verifyCallback}
                      size={useRecaptcha ? "normal" : "invisible"}
                    />
                  )}
                  {errors.captcha_token && (
                    <div className="invalid-feedback d-block">
                      {errors.captcha_token}
                    </div>
                  )}

                  <input
                    type="submit"
                    value="送出"
                    className="btn btn-info btn-block"
                  />
                  <Link to={home_link} className="btn btn-secondary btn-block">
                    取消
                  </Link>
                </form>
                <ReactModal
                  isOpen={this.state.showModal}
                  contentLabel=""
                  style={{ overlay: { zIndex: 10 } }}
                >
                  <h3 className="text-center">客服中心 提問結果</h3>
                  <hr />
                  <div className="row">
                    <div className="col-sm-12 col-md-4 m-auto">
                      <div className="alert alert-success">
                        <strong>回報單 #{question_id} 提問成功</strong>
                        {isEmpty(user) && (
                          <div>
                            <br />
                            我們已經傳送郵件到您的mail，
                            <br />
                            後續追蹤客服請用提問mail或手機及以下代碼查詢：
                            <font color="red" face="cursive">
                              <b>{check_id}</b>
                            </font>
                            <br />
                            <font color="red">
                              註:專員將會回覆至<strong>回報紀錄</strong>
                              頁面給您，務必自行前往查看。
                            </font>
                          </div>
                        )}
                      </div>

                      <button
                        onClick={this.handleCloseModal}
                        className="btn btn-primary m-auto"
                      >
                        確認
                      </button>
                    </div>
                  </div>
                </ReactModal>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ReportQuestion.propTypes = {
  renderForm: PropTypes.func.isRequired,
  createWebReport: PropTypes.func.isRequired,
  errors: PropTypes.object,
};
const mapStateToProps = (state) => ({
  report: state.report,
  errors: state.errors,
  service: state.service,
});
export default connect(mapStateToProps, { renderForm, createWebReport })(
  ReportQuestion
);
